<header></header>
<section  [class]="storyEditor ? 'mainContainer storyEditor' : 'mainContainer'">
  <aside class='leftMenu' id="collapsedLeftMenu"></aside>
  <article class="rightListContainer">
    <div class="connectionstatus" *ngIf="!onlineFlag">
      <span [class]="'statustext black'">Offline</span>
    </div>
    <router-outlet></router-outlet>
  </article>
</section>
